import errorUtil from '~/utils/error';

const useNotify = () => {
  const toast = useToast();
  const reportStore = useReportStore();  

  const errorWithoutLog = (error: unknown): void => {
    const message = errorUtil.handleErrorMessage(error);

    toast.add({
      id: message,
      title: message,
      color: 'rose'
    });
  };

  const error = (error: unknown): void => {
    const message = errorUtil.handleErrorMessage(error);

    reportStore.saveLog({
      message: `[CUSTOMER]: ${message}`
    });

    toast.add({
      title: message,
      color: 'rose'
    });
  };

  const success = (message: string): void => {
    toast.add({
      title: message,
      color: 'green'
    });
  };

  return {
    error,
    success,
    errorWithoutLog
  };
};

export { useNotify };
